var androids = [{
    key: "B00OSTKZWM",
    category: "android",
    name: "RCA M1 4.0 Unlocked Cell Phone, Dual SIM, 5MP Camera, Android 4.4, 1.3GHz (White)",
    seller: "RCA",
    wholePrice: "57",
    priceFraction: "99",
    stock: 96,
    star: 3,
    starCount: 620,
    img: "https://images-na.ssl-images-amazon.com/images/I/51VCP05020L._AC_US218_.jpg",
    url: "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_atf_electronics_sr_pg1_1?ie=UTF8&adId=A03332262DHW9SCX1W5WM&url=https%3A%2F%2Fwww.amazon.com%2FRCA-M1-Unlocked-Camera-Android%2Fdp%2FB00OSTKZWM%2Fref%3Dsr_1_1%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124826%26sr%3D1-1-spons%26keywords%3Dandroid%26psc%3D1&qualifier=1499124825&id=1141793968325395&widgetName=sp_atf",
    features: [{
        description: "Display Size",
        value: "4.0 inches",
    },
    {
        description: "Computer Memory Size",
        value: "4 GB",
    },
    {
        description: "Operating System",
        value: "Android",
    },
    {
        description: "Cpu Model Speed",
        value: "1.3 GHz",
    },
    {
        description: "Special Feature",
        value: "smartphone",
    },
    ],
    price: 57.99,
    shipping: 3.99,
},
{
    key: "B01H2E0J5M",
    category: "android",
    name: "BLU R1 HD - 16 GB - Black - Prime Exclusive - with Lockscreen Offers & Ads",
    seller: "BLU",
    wholePrice: "59",
    priceFraction: "99",
    stock: 5,
    star: 3,
    starCount: 2318,
    img: "https://images-na.ssl-images-amazon.com/images/I/416TS-ODxfL._AC_US218_.jpg",
    url: "https://www.amazon.com/BLU-R1-HD-Exclusive-Lockscreen/dp/B01H2E0J5M/ref=sr_1_2?s=electronics&ie=UTF8&qid=1499124822&sr=1-2&keywords=android",
    features: [{
        description: "Display Size",
        value: "5.0 inches",
    },
    {
        description: "Computer Memory Size",
        value: "16 GB",
    },
    {
        description: "Operating System",
        value: "Android 6.0 Marshmallow",
    },
    {
        description: "Display Type",
        value: "LCD",
    },
    {
        description: "Special Feature",
        value: "card slots",
    },
    ],
    price: 59.99,
    shipping: 7.99,
},
{
    key: "B0713WPJKX",
    category: "android",
    name: "Celltronics Micro USB Cable,10FT Nylon Braided Tangle-free Data Sync Heavy Duty Android Charging Cable Power Cord High Speed USB2.0 for Samsung HTC LG MP3 Bluetooth Speaker-3 Pack",
    seller: "Cell-Tronics",
    wholePrice: "10",
    priceFraction: "99",
    stock: 87,
    star: 4,
    starCount: 3392,
    img: "https://images-na.ssl-images-amazon.com/images/I/61+-qmTKy8L._AC_US218_.jpg",
    url: "https://www.amazon.com/Celltronics-Tangle-free-Charging-Bluetooth-Speaker-3/dp/B0713WPJKX/ref=sr_1_3?s=electronics&ie=UTF8&qid=1499124822&sr=1-3&keywords=android",
    features: [],
    price: 10.99,
    shipping: 3.99,
},
{
    key: "B01LPZD1N6",
    category: "android",
    name: 'ATOTO 7"HD Touchscreen 2Din Android Car Navigation Stereo - Quadcore Car Entertainment Multimedia w/ FM/RDS Radio,WIFI,BT,Mirror Link,and more(No DVD Player)M4171 (178101/16G)',
    seller: "ATOTO",
    wholePrice: "164",
    priceFraction: "90",
    stock: 20,
    star: 3,
    starCount: 4029,
    img: "https://images-na.ssl-images-amazon.com/images/I/51xI8gJTNYL._AC_US218_.jpg",
    url: "https://www.amazon.com/ATOTO-Touchscreen-Android-Navigation-Stereo/dp/B01LPZD1N6/ref=sr_1_4?s=electronics&ie=UTF8&qid=1499124822&sr=1-4&keywords=android",
    features: [{
        description: "Display Size",
        value: "7.0 inches",
    },
    {
        description: "Operating System",
        value: "Android",
    },
    {
        description: "Hardware Platform",
        value: "Android",
    },
    {
        description: "Cpu Model Manufacturer",
        value: "MTK",
    },
    {
        description: "Wireless Communication Technology",
        value: "AM/FM",
    },
    ],
    price: 164.9,
    shipping: 0,
},
{
    key: "B01N1SE4EP",
    category: "android",
    name: "NeuTab 7 inch Quad Core Android 5.1 Lollipop Tablet PC, Bluetooth 4.0, Dual Camera, FCC Certified(2017 Upgraded Edition)",
    seller: "NeuTab",
    wholePrice: "49",
    priceFraction: "99",
    stock: 50,
    star: 3,
    starCount: 4947,
    img: "https://images-na.ssl-images-amazon.com/images/I/41HNbRSKpfL._AC_US218_.jpg",
    url: "https://www.amazon.com/NeuTab-Lollipop-Bluetooth-Certified-Upgraded/dp/B01N1SE4EP/ref=sr_1_5?s=electronics&ie=UTF8&qid=1499124822&sr=1-5&keywords=android",
    features: [{
        description: "Display Size",
        value: "7.0 inches",
    },
    {
        description: "Operating System",
        value: "android 5.1 (Lollipop)",
    },
    {
        description: "Hard Disk Size",
        value: "8.0 GB",
    },
    {
        description: "Connectivity Technology",
        value: "usb",
    },
    {
        description: "System Ram Type",
        value: "ddr3 sdram",
    },
    ],
    price: 49.99,
    shipping: 7.99,
},
{
    key: "B017LDNLIG",
    category: "android",
    name: "Tracfone Alcatel Onetouch Pixi Glitz A463BG",
    seller: "Tracfone",
    wholePrice: "19",
    priceFraction: "94",
    stock: 85,
    star: 3,
    starCount: 381,
    img: "https://images-na.ssl-images-amazon.com/images/I/51QdgznaNTL._AC_US218_.jpg",
    url: "https://www.amazon.com/Tracfone-Alcatel-Onetouch-Glitz-A463BG/dp/B017LDNLIG/ref=sr_1_6?s=electronics&ie=UTF8&qid=1499124822&sr=1-6&keywords=android",
    features: [{
        description: "Display Size",
        value: "3.5",
    },
    {
        description: "Computer Memory Size",
        value: "2 GB",
    },
    {
        description: "Operating System",
        value: "Android 4.4 KitKat",
    },
    {
        description: "Display Type",
        value: "LCD",
    },
    {
        description: "Special Feature",
        value: "smartphone",
    },
    ],
    price: 19.94,
    shipping: 7.99,
},
{
    key: "B018IZ0SWI",
    category: "android",
    name: "BLU Advance 5.0 - Unlocked Dual Sim Smartphone - US GSM - Black",
    seller: "BLU",
    wholePrice: "59",
    priceFraction: "99",
    stock: 10,
    star: 3,
    starCount: 395,
    img: "https://images-na.ssl-images-amazon.com/images/I/41mXjdLezRL._AC_US218_.jpg",
    url: "https://www.amazon.com/BLU-Advance-5-0-Unlocked-Smartphone/dp/B018IZ0SWI/ref=sr_1_7?s=electronics&ie=UTF8&qid=1499124822&sr=1-7&keywords=android",
    features: [{
        description: "Display Size",
        value: "5 inches",
    },
    {
        description: "Computer Memory Size",
        value: "4 GB",
    },
    {
        description: "Operating System",
        value: "Android",
    },
    {
        description: "Wireless Communication Technology",
        value: "GSM, 3G, 4G",
    },
    {
        description: "Cpu Model Speed",
        value: "1 GHz",
    },
    ],
    price: 59.99,
    shipping: 3.99,
},
{
    key: "B01N4HS7B8",
    category: "android",
    name: "Smart tv box Wechip V5 Android 6.0 Marshmallow 2g 16g Amlogic S905X quad core 4K Dual WiFi",
    seller: "Wechip",
    wholePrice: "53",
    priceFraction: "99",
    stock: 34,
    star: 4,
    starCount: 4740,
    img: "https://images-na.ssl-images-amazon.com/images/I/41q+adG0lNL._AC_US218_.jpg",
    url: "https://www.amazon.com/Smart-Wechip-Android-Marshmallow-Amlogic/dp/B01N4HS7B8/ref=sr_1_8?s=electronics&ie=UTF8&qid=1499124822&sr=1-8&keywords=android",
    features: [],
    price: 53.99,
    shipping: 7.99,
},
{
    key: "B01LX0JZUM",
    category: "android",
    name: "ONSON Android Charger Cable,3Pack 10FT Extra Long Nylon Braided High Speed 2.0 USB to Micro USB Charging Cord Fast Charger Cable for Samsung Galaxy S7/S6 Edge,Note 5/4,HTC,LG,Nexus(Gray White)",
    seller: "ONSON",
    wholePrice: "11",
    priceFraction: "99",
    stock: 8,
    star: 3,
    starCount: 2636,
    img: "https://images-na.ssl-images-amazon.com/images/I/51P8qI8KzNL._AC_US218_.jpg",
    url: "https://www.amazon.com/ONSON-Android-Charger-Braided-Charging/dp/B01LX0JZUM/ref=sr_1_9?s=electronics&ie=UTF8&qid=1499124822&sr=1-9&keywords=android",
    features: [],
    price: 11.99,
    shipping: 3.99,
},
{
    key: "B072NYXDLY",
    category: "android",
    name: '5.0" Phone Unlocked Dual Sim Quad Core 8GB Android 5.1 Cellphone Gold by TIMMY',
    seller: "Timmy",
    wholePrice: "68",
    priceFraction: "99",
    stock: 14,
    star: 5,
    starCount: 1182,
    img: "https://images-na.ssl-images-amazon.com/images/I/411fzxxuuFL._AC_US218_.jpg",
    url: "https://www.amazon.com/Phone-Unlocked-Android-Cellphone-TIMMY/dp/B072NYXDLY/ref=sr_1_10?s=electronics&ie=UTF8&qid=1499124822&sr=1-10&keywords=android",
    features: [{
        description: "Display Size",
        value: "5.0 inches",
    },
    {
        description: "Operating System",
        value: "google android",
    },
    ],
    price: 68.99,
    shipping: 3.99,
},
{
    key: "B071RK857H",
    category: "android",
    name: "QacQoc A12 Pro Android 6.0 TV BOX Amlogic S912 Octa-Core [2G DDR3/16G eMMC] Dual Wifi 2.4G/5G AC OTA Update 4K 1000M Android TV Box",
    seller: "QacQoc",
    wholePrice: "65",
    priceFraction: "99",
    stock: 1,
    star: 5,
    starCount: 1836,
    img: "https://images-na.ssl-images-amazon.com/images/I/51+GT3mluJL._AC_US218_.jpg",
    url: "https://www.amazon.com/QacQoc-A12-Android-Amlogic-Octa-Core/dp/B071RK857H/ref=sr_1_11?s=electronics&ie=UTF8&qid=1499124822&sr=1-11&keywords=android",
    features: [{
        description: "Connectivity Technology",
        value: "wi-fi ready",
    },
    {
        description: "Special Feature",
        value: "network ready",
    },
    ],
    price: 65.99,
    shipping: 7.99,
},
{
    key: "B06XWMQRS6",
    category: "android",
    name: "QacQoc M9C max Android 6.0 Marshmallow TV Box New Amlogic S905X Chipset [2G DDR3/16G eMMC] 4K Smart Box Unlocked 2.4G WIFI Media Player",
    seller: "QacQoc",
    wholePrice: "49",
    priceFraction: "99",
    stock: 54,
    star: 4,
    starCount: 2618,
    img: "https://images-na.ssl-images-amazon.com/images/I/41Sx5HrzuhL._AC_US218_.jpg",
    url: "https://www.amazon.com/QacQoc-Android-Marshmallow-Amlogic-Unlocked/dp/B06XWMQRS6/ref=sr_1_12?s=electronics&ie=UTF8&qid=1499124822&sr=1-12&keywords=android",
    features: [],
    price: 49.99,
    shipping: 3.99,
},
{
    key: "B01N41AKT3",
    category: "android",
    name: "Antimi Sweatproof Smart Watch Phone for Android HTC Sony Samsung LG Google Pixel /Pixel and iPhone 5 5S 6 6 Plus 7 Smartphones Black",
    seller: "Antimi",
    wholePrice: "25",
    priceFraction: "99",
    stock: 66,
    star: 3,
    starCount: 3316,
    img: "https://images-na.ssl-images-amazon.com/images/I/41Z3XFc1-5L._AC_US218_.jpg",
    url: "https://www.amazon.com/Antimi-Sweatproof-Android-Samsung-Smartphones/dp/B01N41AKT3/ref=sr_1_13?s=electronics&ie=UTF8&qid=1499124822&sr=1-13&keywords=android",
    features: [{
        description: "Operating System",
        value: "Android/iOS",
    },
    {
        description: "Hardware Platform",
        value: "Android",
    },
    ],
    price: 25.99,
    shipping: 3.99,
},
{
    key: "B06XY8W1DC",
    category: "android",
    name: "SUNNZO T2 TV Box Streaming Devices for TV/Streaming Media Players Android 6.0 4K WIFI",
    seller: "sunnzo",
    wholePrice: "29",
    priceFraction: "99",
    stock: 97,
    star: 3,
    starCount: 4951,
    img: "https://images-na.ssl-images-amazon.com/images/I/51sZTRzpQjL._AC_US218_.jpg",
    url: "https://www.amazon.com/T2-Streaming-Devices-Players-Android/dp/B06XY8W1DC/ref=sr_1_14?s=electronics&ie=UTF8&qid=1499124822&sr=1-14&keywords=android",
    features: [],
    price: 29.99,
    shipping: 7.99,
},
{
    key: "B01N0VVQ13",
    category: "android",
    name: "Goodsail Micro USB Cables, 3Pack 6FT/2M durable Nylon Braided High Charging Speed USB 2.0 A Male to Micro USB Cord For Samsung, HTC, Motorola, Blackberry, Tablets and Android Smartphones Blue Black",
    seller: "Goodsail",
    wholePrice: "9",
    priceFraction: "99",
    stock: 80,
    star: 4,
    starCount: 4758,
    img: "https://images-na.ssl-images-amazon.com/images/I/51+MK7D4pLL._AC_US218_.jpg",
    url: "https://www.amazon.com/Goodsail-Charging-Motorola-Blackberry-Smartphones/dp/B01N0VVQ13/ref=sr_1_15?s=electronics&ie=UTF8&qid=1499124822&sr=1-15&keywords=android",
    features: [],
    price: 9.99,
    shipping: 7.99,
},
{
    key: "B01JOT42JW",
    category: "android",
    name: "2017 Model GooBang Doo Android 6.0 TV Box, Abox Android TV Box Amlogic S905X 64 Bits and True 4K Playing",
    seller: "GooBang Doo",
    wholePrice: "39",
    priceFraction: "99",
    stock: 54,
    star: 3,
    starCount: 856,
    img: "https://images-na.ssl-images-amazon.com/images/I/41sPPh71RXL._AC_US218_.jpg",
    url: "https://www.amazon.com/GooBang-Doo-Android-Amlogic-Playing/dp/B01JOT42JW/ref=sr_1_16?s=electronics&ie=UTF8&qid=1499124822&sr=1-16&keywords=android",
    features: [],
    price: 39.99,
    shipping: 3.99,
},
{
    key: "B06Y5PY61J",
    category: "android",
    name: "RBSCH M96X Smart Tv Box Android 6.0 Amlogic S905X Quad Core 64bit 2GB / 8GB 4K HD 100Mbps LAN Wifi Mini Home player",
    seller: "RBSCH",
    wholePrice: "44",
    priceFraction: "99",
    stock: 34,
    star: 5,
    starCount: 1151,
    img: "https://images-na.ssl-images-amazon.com/images/I/41c3yiJtjCL._AC_US218_.jpg",
    url: "https://www.amazon.com/RBSCH-Android-Amlogic-100Mbps-player/dp/B06Y5PY61J/ref=sr_1_17?s=electronics&ie=UTF8&qid=1499124822&sr=1-17&keywords=android",
    features: [],
    price: 44.99,
    shipping: 7.99,
},
{
    key: "B0182YJ4V6",
    category: "android",
    name: "Yezz Andy 3.5E2 unlocked android phone black",
    seller: "Yezz",
    wholePrice: "37",
    priceFraction: "50",
    stock: 97,
    star: 3,
    starCount: 2770,
    img: "https://images-na.ssl-images-amazon.com/images/I/51PADZ7CaeL._AC_US218_.jpg",
    url: "https://www.amazon.com/Yezz-3-5E2-unlocked-android-phone/dp/B0182YJ4V6/ref=sr_1_18?s=electronics&ie=UTF8&qid=1499124822&sr=1-18&keywords=android",
    features: [{
        description: "Display Size",
        value: "3.5 inches",
    },
    {
        description: "Computer Memory Size",
        value: "512.0 MB",
    },
    {
        description: "Operating System",
        value: "google android",
    },
    {
        description: "Wireless Communication Technology",
        value: "GSM",
    },
    {
        description: "Special Feature",
        value: "smartphone",
    },
    ],
    price: 37.5,
    shipping: 7.99,
},
{
    key: "B01GL7EB50",
    category: "android",
    name: "Pandawell OTG Micro USB Mobile Phone Fan Portable Dock Cool Cooler Rotating Fan for Samsung Galaxy S7, S7 Edge, LG G5 & Other Android Smart Phone (Black)",
    seller: "Pandawell",
    wholePrice: "4",
    priceFraction: "99",
    stock: 68,
    star: 3,
    starCount: 2806,
    img: "https://images-na.ssl-images-amazon.com/images/I/31Q6QEVwmDL._AC_US218_.jpg",
    url: "https://www.amazon.com/Pandawell-Portable-Rotating-Samsung-Android/dp/B01GL7EB50/ref=sr_1_19?s=electronics&ie=UTF8&qid=1499124822&sr=1-19&keywords=android",
    features: [],
    price: 4.99,
    shipping: 7.99,
},
{
    key: "B06XKH29C8",
    category: "android",
    name: "TYD 10.1 inch Tablet Android 6.0 GPS Octa Core 2560X1600 IPS Bluetooth RAM 4GB ROM 64GB 13.0MP 3G Phone Call Tablets PC Dual sim card TYD-107-Black",
    seller: "Tianyida",
    wholePrice: "99",
    priceFraction: "00",
    stock: 95,
    star: 2,
    starCount: 1718,
    img: "https://images-na.ssl-images-amazon.com/images/I/513RoqwKmPL._AC_US218_.jpg",
    url: "https://www.amazon.com/Android-2560X1600-Bluetooth-Tablets-TYD-107-Black/dp/B06XKH29C8/ref=sr_1_20?s=electronics&ie=UTF8&qid=1499124822&sr=1-20&keywords=android",
    features: [{
        description: "Display Size",
        value: "10.1 inches",
    },
    {
        description: "Operating System",
        value: "Android",
    },
    {
        description: "Hard Disk Size",
        value: "64.0 GB",
    },
    {
        description: "Connectivity Technology",
        value: "usb",
    },
    {
        description: "Hardware Platform",
        value: "android 6.0",
    },
    ],
    price: 99,
    shipping: 3.99,
},
{
    key: "B01MG086CV",
    category: "android",
    name: "[Apple Certified] 3 Feet Coiled Charging Cable for iPhone and Android, YellowKnife 8-Pin Lightning & Micro to USB Date Wire for iPhone 5 6 7 Plus SE, iPad Mini Air iPod, Samsung Sony LG Phones, Black",
    seller: "Yellowknife",
    wholePrice: "11",
    priceFraction: "98",
    stock: 3,
    star: 4,
    starCount: 103,
    img: "https://images-na.ssl-images-amazon.com/images/I/41Htivct16L._AC_US218_.jpg",
    url: "https://www.amazon.com/Certified-Charging-Android-YellowKnife-Lightning/dp/B01MG086CV/ref=sr_1_21?s=electronics&ie=UTF8&qid=1499124822&sr=1-21&keywords=android",
    features: [],
    price: 11.98,
    shipping: 7.99,
},
{
    key: "B01MUA1QMU",
    category: "android",
    name: "TracFone Alcatel OneTouch Pixi Eclipse Prepaid Smartphone - Certified Preowned",
    seller: "Tracfone",
    wholePrice: "20",
    priceFraction: "81",
    stock: 66,
    star: 3,
    starCount: 3507,
    img: "https://images-na.ssl-images-amazon.com/images/I/41gV+33qdoL._AC_US218_.jpg",
    url: "https://www.amazon.com/TracFone-Alcatel-OneTouch-Pixi-Eclipse-Prepaid-Smartphone-Certified/dp/B01MUA1QMU/ref=sr_1_22?s=electronics&ie=UTF8&qid=1499124822&sr=1-22&keywords=android",
    features: [{
        description: "Display Size",
        value: "4",
    },
    {
        description: "Display Type",
        value: "LCD",
    },
    ],
    price: 20.81,
    shipping: 7.99,
},
{
    key: "B015MJLEUS",
    category: "android",
    name: "Anker [3-Pack] PowerLine Micro USB (3ft) - Charging Cable for Samsung, Nexus, LG, Android Smartphones and More (Black)",
    seller: "Anker",
    wholePrice: "10",
    priceFraction: "99",
    stock: 75,
    star: 4,
    starCount: 315,
    img: "https://images-na.ssl-images-amazon.com/images/I/41pKUQFLc8L._AC_US218_.jpg",
    url: "https://www.amazon.com/Anker-3-Pack-PowerLine-Micro-USB/dp/B015MJLEUS/ref=sr_1_23?s=electronics&ie=UTF8&qid=1499124822&sr=1-23&keywords=android",
    features: [],
    price: 10.99,
    shipping: 3.99,
},
{
    key: "B06WWPFVNV",
    category: "android",
    name: "Antimi SmartWatch Sweatproof Smart Watch Phone for Android HTC Sony Samsung LG Google Pixel /Pixel and iPhone 5 5S 6 6 Plus 7 Smartphones Black",
    seller: "Antimi",
    wholePrice: "34",
    priceFraction: "99",
    stock: 37,
    star: 4,
    starCount: 1880,
    img: "https://images-na.ssl-images-amazon.com/images/I/51yaeSUl8DL._AC_US218_.jpg",
    url: "https://www.amazon.com/Antimi-SmartWatch-Sweatproof-Android-Smartphones/dp/B06WWPFVNV/ref=sr_1_24?s=electronics&ie=UTF8&qid=1499124822&sr=1-24&keywords=android",
    features: [{
        description: "Operating System",
        value: "Android/iOS",
    },
    {
        description: "Hardware Platform",
        value: "Android",
    },
    ],
    price: 34.99,
    shipping: 7.99,
},
{
    key: "B00NH2COZC",
    category: "android",
    name: "Native Union NIGHT Cable for Android Devices 10ft Micro-USB to USB Charging Cable (Zebra)",
    seller: "Native Union",
    wholePrice: "39",
    priceFraction: "99",
    stock: 73,
    star: 3,
    starCount: 1894,
    img: "https://images-na.ssl-images-amazon.com/images/I/3167uhg4DPL._AC_US218_.jpg",
    url: "https://www.amazon.com/Native-Union-Android-Micro-USB-Charging/dp/B00NH2COZC/ref=sr_1_25?s=electronics&ie=UTF8&qid=1499124822&sr=1-25&keywords=android",
    features: [],
    price: 39.99,
    shipping: 7.99,
},
{
    key: "B01DMVLE7Q",
    category: "android",
    name: 'Samsung Galaxy Tab E Lite 7.0" 8GB (Wi-Fi) Black Accessory Bundle includes Tablet, Cleaning Kit, 3 Stylus Pens and Metal Ear Buds',
    seller: "Samsung",
    wholePrice: "129",
    priceFraction: "99",
    stock: 14,
    star: 4,
    starCount: 1362,
    img: "https://images-na.ssl-images-amazon.com/images/I/51jViuKHqdL._AC_US218_.jpg",
    url: "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_btf_electronics_sr_pg1_1?ie=UTF8&adId=A06599961RWOD7JVO4914&url=https%3A%2F%2Fwww.amazon.com%2FSamsung-Galaxy-Accessory-Bundle-Cleaning%2Fdp%2FB01DMVLE7Q%2Fref%3Dsr_1_26%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124822%26sr%3D1-26-spons%26keywords%3Dandroid%26psc%3D1&qualifier=1499124826&id=4777421193755769&widgetName=sp_btf",
    features: [{
        description: "Display Size",
        value: "7.0 inches",
    },
    {
        description: "Computer Memory Size",
        value: "1.0 GB",
    },
    {
        description: "Operating System",
        value: "Android",
    },
    {
        description: "Connectivity Technology",
        value: "wi-fi",
    },
    {
        description: "Wireless Communication Technology",
        value: "Wi-Fi",
    },
    ],
    price: 129.99,
    shipping: 7.99,
},
{
    key: "B017SD8RWO",
    category: "android",
    name: "Zmodo Outdoor Wireless IP Security Surveillance Camera System - 4 Pack HD Night Vision Remote Access Motion Detection",
    seller: "Zmodo",
    wholePrice: "99",
    priceFraction: "99",
    stock: 9,
    star: 3,
    starCount: 4638,
    img: "https://images-na.ssl-images-amazon.com/images/I/51jegGDgy2L._AC_US218_.jpg",
    url: "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_btf_electronics_sr_pg1_2?ie=UTF8&adId=A07535107J9TJPUG5AAX&url=https%3A%2F%2Fwww.amazon.com%2FZmodo-Outdoor-Wireless-Security-Surveillance%2Fdp%2FB017SD8RWO%2Fref%3Dsr_1_27%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124822%26sr%3D1-27-spons%26keywords%3Dandroid%26psc%3D1&qualifier=1499124826&id=4777421193755769&widgetName=sp_btf",
    features: [],
    price: 99.99,
    shipping: 0,
},
{
    key: "B01N5PRSOT",
    category: "android",
    name: "EVANPO Android 6.0 TV BOX Amlogic S905X Quad Core 1GB DDR3 8GB EMMC Flash 3D 4K2K Smart Mini PC Wifi TV Player Set Top Box with Keyboard",
    seller: "EVANPO",
    wholePrice: "48",
    priceFraction: "98",
    stock: 47,
    star: 4,
    starCount: 88,
    img: "https://images-na.ssl-images-amazon.com/images/I/51JVSEmcsCL._AC_US218_.jpg",
    url: "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_btf_electronics_sr_pg1_3?ie=UTF8&adId=A00155643QO9QUBJOBSJT&url=https%3A%2F%2Fwww.amazon.com%2FEVANPO-Android-Amlogic-Player-Keyboard%2Fdp%2FB01N5PRSOT%2Fref%3Dsr_1_28%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124822%26sr%3D1-28-spons%26keywords%3Dandroid%26psc%3D1&qualifier=1499124826&id=4777421193755769&widgetName=sp_btf",
    features: [],
    price: 48.98,
    shipping: 7.99,
},
];

export default androids;